import { Box, Card, CardContent, Grid } from "@mui/material";
import React from "react";
import CardTitle from "./CardTitle";
import "./ShimPanel.css";
import { useSelector } from "react-redux";
import { roundToX } from "../../common/common";

export default function ShimsCard(props) {
    const laserData = useSelector(state => state.laserData);
    const micron = 0.00003937;
    return (
            <Card 
                raised={false}
                variant="outlined" 
                sx={{paddingLeft:"16px", paddingRight:"16px", marginTop:"7px"}}
            >
                <CardTitle title="Shims"/>
                <CardContent className="shim-panel" >
                    <Box>
                        <Grid
                            container
                            direction="row"
                            sx={{marginLeft:"auto",marginRight:"auto"}} 
                            >
                            <Box className="shim-column shim-label" >&nbsp;</Box>
                            <Box className="shim-column shim-caption" >&nbsp;</Box>
                            <Box className="shim-column shim-caption" >&nbsp;</Box>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            sx={{marginLeft:"auto",marginRight:"auto"}} 
                            >
                            <Box className="shim-column shim-label" ></Box>
                            <Box className="shim-column shim-caption" >Front</Box>
                            <Box className="shim-column shim-caption" >Rear</Box>
                        </Grid>
                        <Grid
                        container
                        direction="row"
                        >
                            <Box className="shim-column shim-label">Vertical</Box>
                            <Box className="shim-column shim-value">{`${roundToX(laserData.shim.frontVertical * micron, 3).toFixed(3)}`}</Box>
                            <Box className="shim-column shim-value">{`${roundToX(laserData.shim.rearVertical * micron, 3).toFixed(3)}`}</Box>
                        </Grid>
                        <Grid
                        container
                        direction="row"
                        >
                            <Box className="shim-column shim-label">Horizontal</Box>
                            <Box className="shim-column shim-value">{`${roundToX(laserData.shim.frontHorizontal * micron, 3).toFixed(3)}`}</Box>
                            <Box className="shim-column shim-value">{`${roundToX(laserData.shim.rearHorizontal * micron, 3).toFixed(3)}`}</Box>
                        </Grid>
                    </Box>
                </CardContent>
            </Card>
    )
}